import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireMenuOrRedirect } from '@/lib/auth/require-permission';

export const Route = createFileRoute('/_app/ads/operators')({
  beforeLoad: requireMenuOrRedirect('menu:ads-admin:operators', '/ads/accounts'),
  component: () => <Outlet />,
});
